var t=/^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/,e={isValid:function(e){return t.test(e)}};export default e;
